export default __webpack_public_path__ + "static/media/dissapointed.b39460f1.mp3";